<template>
  <div>
    <div ref="h_top">
      <van-nav-bar class="bg-gradual-blue" title="座位预约" left-text="返回" @click-left="goback();" left-arrow />
    </div>
    <div>
      <div class="wrapper" :style="{height: conH}" ref="h_cont">
        <div class="cinema-wrapper">
          <div class="seat-wrapper">
            <div class="screen">{{room.schName}}{{room.libName}}{{room.name}}</div>
            <div class="inner-seat-wrapper room-bg" ref="innerSeatWrapper" >
              <div v-if="maxRow > 0" v-for="(row,ridx) in maxRow">
                <div v-for="(col,cidx) in maxCol" class="seat" :style="{width:seatSize+'px',height:seatSize+'px',lineHeight:seatSize*0.8+'px'}">
                  <div v-if="seatList[ridx][cidx].s != 0" class="inner-seat" 
                    @click="handleChooseSeat(ridx,cidx)" 
                    :class="seatClass[seatList[ridx][cidx].s]">
                    {{seatList[ridx][cidx].no}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="padding:10px 20px;">
          <van-button @click="NextStep()" style="border-radius: 0.53333rem;" type="info" block>{{selectSeat.id ? '已选择'+selectSeat.no+'座' : '选择座位'}}</van-button>
        </div>
      </div>
    </div>
	
	<van-dialog v-model="show" title="预约确认" show-cancel-button @confirm="saveReserve">
	  <div style="padding: 10px 20px;color: #a0a0a0;">
		  <table>
			  <tr>
				 <td>1.</td>
				 <td>预约后请在开始时间后半个小时内刷卡开门，刷卡开门后预约时间段内均可刷卡开门。</td>
			  </tr>
			  <tr>
			  	<td>2.</td>
			  	<td>预约当前时段时，门锁需等待系统更新数据，请在3分钟后刷卡开门。</td>
			  </tr>
			  <tr>
			  	<td>3.</td>
			  	<td>如遇预约时间内刷卡开始失败，请联系宿管人员。</td>
			  </tr>
		  </table>
	  </div>
	</van-dialog>
  </div>
</template>

<script>
  import { loadData ,showToast , hideToast } from '@/utils/common'
  import { Toast , Dialog } from 'vant';

export default {
  props: {
    rdata: {
      type: Object,
      default: () => {}
    }
  },
  components: { Toast  },
  data() {
    return {
      //座位尺寸
      seatSize:'',
      //推荐选座最大数量
      maxRow:0,
      maxCol:0,
      seatList:[],
      room:{},
      conH:'1000px',
      selectSeat:{},
      seatClass:['','kx-seat','rz-seat','jy-seat','yx-seat'],
	  show:false
    }
  },
  mounted() {
    this.loadSeat();
    this.initH();
  },
  methods:{
    initH(){
      let fh = document.documentElement.clientHeight;
      let bh = this.$store.state.bottomH;
      let th = this.$refs.h_top.offsetHeight;
      this.conH = (fh - th - bh)+'px';
      //this.$refs.h_cont.style.height = (fh - th - bh)+'px';
    },
    goback(){
      this.$emit("notice",  {'page':'seat','isback':'1'})
    },
    NextStep(){
      if(!this.selectSeat.id){
        Toast('请先选择一个座位！');
        return;
      }
	  this.show = true;
    },
	saveReserve(){
		let that = this;
		var paramsJson = {
		  "seatId": that.selectSeat.id,
		  "roomId": that.rdata.roomId + '',
		  "dateStr": that.rdata.orderDate,
		  "startHour": that.rdata.startHourStr,
		  "endHour": that.rdata.endIndex,
		  "userId": sessionStorage.getItem('login_userid'),
		  "libId": that.rdata.libId,
		  "token":sessionStorage.getItem('login_token')
		};
		showToast();
		loadData('/appSeat/doPreSeat',paramsJson).then(res => {
				hideToast();
		  if(res && res.code == 0){
		    this.$emit("notice",  {'page':'seat'})
		  }else{
		    Toast(res.message);
		  }
		}).catch(() => {
				hideToast();
		  Toast('网络异常请稍后重试！');
		})
	},
    loadSeat(){
      // 异步更新数据
      let _this = this;
      let paramsJson = {
        "roomId": _this.rdata.roomId + '',
        "dateStr": _this.rdata.orderDate,
        "startTime": _this.rdata.startHourStr,
        "endTime": _this.rdata.endIndex
      };
      loadData('/appSeat/querySeatList',paramsJson).then(res => {
        if(res && res.code == 0){
          let wd = document.body.clientWidth;
          this.seatSize = this.$refs.innerSeatWrapper ? parseInt(parseInt(window.getComputedStyle(this.$refs.innerSeatWrapper).width,10) / res.data.room.maxC,10):0;
          //this.seatSize = parseInt(parseInt(wd) / res.data.maxC,10);
          this.maxRow = res.data.room.maxR;
          this.maxCol = res.data.room.maxC;
          this.seatList = res.data.list;
          this.room = res.data.room;

          let tw = this.$refs.innerSeatWrapper.offsetWidth;
          let rate = parseInt(this.room.planHeight) / parseInt(this.room.planWidth) * tw;
          this.$refs.innerSeatWrapper.style.height = rate+'px';
        }
      }).catch(() => {

      })
    },



      //处理座位选择逻辑
      handleChooseSeat: function(row,col){
        let seat = this.seatList[row][col];
        let seatS = this.seatList[row][col].s;
        //不可选座位，直接返回
        if(seatS===2 || seatS===3) return
        //已选变未选
        if(seatS === 1){
          seat.s = 4;
        }else if(seatS === 4){
          seat.s = 1;
        }
        if(this.selectSeat){
          this.selectSeat.s = 1;
        }
        this.selectSeat = seat;

      }

    },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrapper{
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
  }
  .cinema-wrapper{
    height:80%;
    overflow-y: auto;
  }
  .title{
    text-align: center;
  }
  .seat-wrapper{
    height:100%;
    width:100%;
    border:1px dotted #c5c5c5;
    margin: 0 auto;
    position: relative;
    overflow: auto;
  }
  .screen{
    margin: 0 auto;
    height:30px;
    width:50%;
    background-color: #e3e3e3;
    border-radius: 0 0 15px 15px;
    color: #585858;
    line-height: 30px;
    text-align: center;
  }
  .inner-seat-wrapper{
    position: absolute;
    top:40px;
    bottom:0;
    width:100%;
    box-sizing: border-box;
  }
  .seat{
    float:left;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inner-seat{
    width:80%;
    height:80%;
    font-size:60%;
    cursor: pointer;
    text-align: center;
  }
  .yx-seat{
    background: url('./../../../assets/img/seat_yy.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .kx-seat{
    background: url('./../../../assets/img/seat_kx.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .rz-seat{
    background: url('./../../../assets/img/seat_rz.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .jy-seat{
    background: url('./../../../assets/img/seat_jy.png') center center no-repeat;
    background-size: 100% 100%;
  }

  .room-bg{
    background: url('./../../../assets/img/bg_test2.png') center center no-repeat;
    background-size: 100% 100%;
  }

  .screen-center{
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    padding:5px;
    font-size: 13px;
    border-radius: 5px;
    top:50px;
    background-color: #f6f6f6;
    color: #636363;
    border:1px solid #b1b1b1;
  }
  .mid-line{
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    top:100%;
    width:1px;
    height:800px;
    border-left:1px dashed #919191;
  }
  .btn-wrapper{
    margin: 20px auto;
    width:1000px;
    height:30px;
    text-align: center;
  }
  .btn-buy{
    height:100%;
    line-height: 30px;
    font-size: 14px;
    border-radius: 5px;
    padding:0 5px;
    background-color: #ffa349;
    color: #ffffff;
    display: inline-block;
    cursor: pointer;
    margin-right: 10px;
  }
  .smart{
    background-color: #39ac6a;
  }
  .illustration{
    position: absolute;
    left:0;
    top:0;
    height:35px;
    width:300px;
  }
  .illustration-img-wrapper{
    width:25px;
    height:25px;
    position: relative;
    top:50%;
    display: inline-block;
    transform: translateY(-50%);
    margin-left: 10px;
  }
  .illustration-text{
    display: inline-block;
    height:100%;
    line-height: 35px;
    font-size: 14px;
    position: relative;
    top:-2px;
  }

</style>


